import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { redeemCode } from "../../auth";

const AuthLandingPage = (props) => {
  const authorizationCode = new URLSearchParams(window.location.search).get('authorization_code');
  const history = useHistory();

  useEffect(() => {
    const auth = async () => {
      try {
        if (authorizationCode) {
          const token = await redeemCode(authorizationCode);
          props.setToken(token);
          props.setValidAuth(true);
        } else {
          console.error('Authorization code is missing');
          props.setValidAuth(false);
          history.push('/');
        }
      } catch (error) {
        console.error('Validation failed', error);
        props.setValidAuth(false);
        history.push('/');
      }
    };
    auth();
  }, []);

  return (
    <div>
      <h1>One moment, authenticating...</h1>
    </div>
  );
};

export default AuthLandingPage;




// WEBPACK FOOTER //
// ./src/components/Home/AuthLandingPage.js